export default __webpack_public_path__ + "static/media/analytics.e1ecf962.jpg";